import React from 'react'
import Topnavbar from '../Header-pages/Topnavbar'
import Navbar from '../Header-pages/Navbar'
import Footer from '../Header-pages/Footer'
import Whychooseus from '../Header-pages/Whychooseus'
import '../Css/AboutSafproview.css'
import { useNavigate } from 'react-router-dom'

export default function AboutSafproview() {
   const navigate = useNavigate();
  return (
    <>
      <Topnavbar />
      <Navbar />
      
      {/* Hero Section */}
      <div className='company-hero-banner'>
        <img 
          src='/images/Productview.jpg' 
          alt='About Safpro' 
          className='company-hero-img'
        />
        <div className='company-hero-content-wrapper'>
          {/* Breadcrumbs inside hero */}
          <div className='company-breadcrumb-nav'>
            <a onClick={()=>navigate('/')} style={{cursor:'pointer'}} >Home</a>
            <span className='company-breadcrumb-divider'>/</span>
            <span className='company-breadcrumb-active' style={{color:'#fff', cursor:'pointer'}}>About Safpro</span>
          </div>
          
          <div className='company-hero-text'>
            <h1>About Safpro</h1>
            <p>Learn more about our mission, values, and commitment to delivering exceptional software solutions.</p>
          </div>
        </div>
      </div>

      {/* Main Content Section - UPDATED ORDER */}
      <div className="company-main-section">
        <div className="container-fluid container-lg px-3 px-md-4 py-5">
          <div className="row g-5 align-items-start">
            {/* Left Side - Fixed Image Container */}
            <div className="col-lg-6">
              <div className="company-visual-container">
                {/* Main person image */}
                <img src="/images/Man.png" alt="Person" className="company-main-visual" />
                
                {/* Overlay images */}
                <img src="/images/Stars.png" alt="Stars" className="company-overlay-element company-stars" />
                {/* <img src="/images/projects.png" alt="Projects" className="company-overlay-element company-projects" /> */}
                <img src="/images/Growth.png" alt="Growth" className="company-overlay-element company-growth" />
              </div>
            </div>

            {/* Right Side - Scrollable Text Content */}
            <div className="col-lg-6">
              <div className="company-text-container">
                <h2 className="company-primary-heading">
                  SAFPRO TECHNOLOGY SOLUTIONS
                </h2>
                
                <div className="company-content-text">
                  <p>
                    We are an offshore software development company committed to delivering innovative, scalable, and result-driven digital solutions. Our expertise spans across a diverse range of cutting-edge technologies, including web application development, mobile apps, e-commerce platforms, custom portals, digital websites, UI/UX design, digital marketing, software testing, DevOps, AI/ML, Salesforce, and cloud services.
                  </p>

                  <p>
                    At Safpro, our team of skilled professionals is passionate about technology and innovation. We combine deep technical knowledge with creative thinking to build solutions that drive business growth and operational efficiency. Whether it's developing from scratch or enhancing existing systems, we deliver end-to-end software solutions tailored to each client's specific goals and challenges. We also work with open-source platforms to provide flexible, cost-effective, and future-ready applications.
                  </p>

                  <p>
                    Our dedicated development teams act as an extension of your in-house staff, ensuring seamless collaboration, transparent communication, and agile project execution. With a proven 93% customer retention rate, Safpro stands as a trusted partner in long-term digital transformation journeys.
                  </p>

                  {/* <p>
                    We pride ourselves on offering high-quality, cost-efficient solutions through our optimized processes and hybrid outsourcing business model. This allows our clients to scale efficiently, reduce development costs, and accelerate time-to-market without compromising on quality.
                  </p>

                  <p>
                    Our mission is simple — to empower businesses through technology. By leveraging the latest tools, frameworks, and methodologies, we ensure every project we deliver meets the highest standards of performance, security, and user experience.
                  </p>

                  <p>
                    At Safpro, we don't just build software — we build partnerships that foster innovation, trust, and success. From startups to enterprises, we help our clients stay ahead in a rapidly evolving digital landscape.
                  </p> */}
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<Whychooseus />
      <Footer />
    </>
  )
}